// extracted by mini-css-extract-plugin
export default {"skeletonSize":"ImageComponent_skeletonSize__Ox0XX","img":"ImageComponent_img__DVZq8"};